import classnames from 'classnames'
import { ComponentChildren } from 'preact'

interface Props {
  type?: 'button' | 'submit'
  primary?: boolean
  insided?: boolean
  insidedSecondary?: boolean
  insidedPurple?: boolean
  cancel?: boolean
  link?: boolean
  default?: boolean
  success?: boolean
  danger?: boolean
  warning?: boolean
  secondary?: boolean
  toggle?: boolean
  toggleActive?: boolean
  loading?: boolean
  qaClasses?: string
  class?: string
  className?: string
  onClick?: JSX.MouseEventHandler
  style?: string | Object
  disabled?: boolean
  title?: string
  small?: boolean
  medium?: boolean
  children?: ComponentChildren
  cta?: boolean
}

const getButtonClassList = (props: Props) => {
  return classnames(
    {
      btn: true,
      'btn-primary': props.primary,
      'btn--insided-brand': props.insided,
      'btn--purple': props.insidedPurple,
      'btn--insided-secondary-brand': props.insidedSecondary,
      'btn-cancel-link': props.cancel && props.link,
      'btn-default': props.default,
      'btn-success': props.success,
      'btn-danger': props.danger,
      'btn-warning': props.warning,
      'btn-secondary': props.secondary,
      'btn--toggle': props.toggle,
      'is-active': props.toggleActive,
      'is-loading': props.loading,
      'btn--S': props.small,
      'btn--M': props.medium,
      'btn--cta': props.cta,
      'btn-cancel': props.cancel && !props.link
    },
    props.qaClasses,
    props.class,
    props.className
  )
}

/**
 * @deprecated
 * Use Button from `@insided/control/uikit/Button`
 */
const Button = (props: Props) => {
  return (
    <button
      type={props.type ?? 'button'}
      onClick={props.onClick}
      style={props.style}
      disabled={props.disabled}
      className={getButtonClassList(props)}
    >
      <div className='btn--loader loader' />
      <span className='btn__hide-when-loading'>{props.title ?? props.children}</span>
    </button>
  )
}

export default Button
